module.exports = __webpack_public_path__ + "static/media/zhumingye_match_01.05c42386.png";